import { simpleUserSerializerMap } from "lib/serializers/simpleUser";
import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const eContractSerializeMap: SerializeMap<EContract> = {
  agentAcceptedBy: simpleUserSerializerMap,
  agentAcceptedOn: "agent_accepted_on",
  agentDescription: "agent_description",
  agentId: "agent_id",
  agentName: "agent_name",
  agreementId: "agreement_id",
  buyerAcceptanceEmailIds: "buyer_acceptance_email_ids",
  buyerAcceptedBy: simpleUserSerializerMap,
  buyerAcceptedOn: "buyer_accepted_on",
  buyerBusinessId: "buyer_business_id",
  buyerDocumentId: "buyer_document_id",
  code: "code",
  deploymentSaleId: "deployment_sale_id",
  documentId: "document_id",
  generatedOn: "generated_on",
  id: "id",
  permissions: "permissions",
  saleLotIds: "sale_lot_ids",
  type: "type",
  vendorAcceptanceEmailIds: "vendor_acceptance_email_ids",
  vendorAcceptedBy: simpleUserSerializerMap,
  vendorAcceptedOn: "vendor_accepted_on",
  vendorBusinessId: "vendor_business_id",
  vendorDocumentId: "vendor_document_id",
  version: "version",
  voidedBy: simpleUserSerializerMap,
  voidedOn: "voided_on",
};

const nestedObjectMap = {
  agent_accepted_by: "agentAcceptedBy",
  buyer_accepted_by: "buyerAcceptedBy",
  vendor_accepted_by: "vendorAcceptedBy",
  voided_by: "voidedBy",
};

export const serializeEContract = buildSerializer(
  eContractSerializeMap,
  "eContract",
  nestedObjectMap,
);

export const deserializeEContract = buildDeserializer(
  eContractSerializeMap,
  "eContract",
  nestedObjectMap,
);
